import React, { useRef } from 'react';
import { 
  Clock, 
  Plus
} from 'lucide-react';
import { Button } from '../../components/ui/Button';
import SLAPolicyManagement from './SLAPolicyManagement';

const UnifiedSLAManagement = () => {
  const policyManagementRef = useRef(null);

  const handleAddPolicy = () => {
    if (policyManagementRef.current) {
      policyManagementRef.current.openCreateForm();
    }
  };

  return (
    <div className="py-6 space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
              <Clock className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">SLA Management</h1>
              <p className="text-gray-600 dark:text-gray-400 mt-1">
                Comprehensive SLA management and monitoring
              </p>
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <Button 
            onClick={handleAddPolicy}
            className="bg-blue-600 hover:bg-blue-700 text-white flex items-center gap-2"
          >
            <Plus className="h-4 w-4" />
            <span>Create Policies</span>
          </Button>
        </div>
      </div>

      {/* Policy Management Content */}
      <SLAPolicyManagement ref={policyManagementRef} />
    </div>
  );
};

export default UnifiedSLAManagement;

